import type { MaterialDTO } from '~/shared/api/client/news/news.dto';
import type { ExpertNewsDTO } from '~/shared/api/client/expert-news/expert-news.dto';
import { isPartnerArticle } from '~/shared/lib/isPartnerArticle';
import {
  ARTICLE_ROUTE_NAMES,
  buildArticleRequest,
} from '~/shared/lib/buildArticleRequest';
import { useCustomFetch } from '~/shared/lib/useCustomFetch';

type TArticleResponse = (MaterialDTO | ExpertNewsDTO) & {
  // The preview response is a { type, data } wrapper
  data?: MaterialDTO | ExpertNewsDTO;
};

// Partner article: the layout (default.vue, Wrapper.vue, Content.vue) branches
// on useState('is-partner-article'), and during SSR the layout renders before
// the page. So the flag is set here — before render. The middleware performs
// the first article request; the page reads it from the payload by the same
// key (buildArticleRequest), so there is still a single network request.
// The flag is owned by this middleware only: any non-article route gets false.
export default defineNuxtRouteMiddleware(async (to) => {
  const isPartnerView = useState<boolean>('is-partner-article', () => false);

  if (!ARTICLE_ROUTE_NAMES.includes(String(to.name))) {
    isPartnerView.value = false;
    return;
  }

  const isFirstLoadArticle = useState<boolean>(
    'isFirstLoadArticle',
    () => true,
  );

  const request = buildArticleRequest(to, isFirstLoadArticle.value);

  if (!request) {
    // Invalid id — the page will throw a 404
    isPartnerView.value = false;
    return;
  }

  const { data } = await useCustomFetch<TArticleResponse>(request.url, {
    method: 'GET',
    key: request.key,
  });

  isFirstLoadArticle.value = false;

  const item = request.isPreview ? data.value?.data : data.value;
  isPartnerView.value = isPartnerArticle(item);
});
